// extracted by mini-css-extract-plugin
export default {"reference":"Reference_reference__6M3Cq","referenceDiv":"Reference_referenceDiv__-mwr6","image":"Reference_image__bjX7E"};